import { create } from 'zustand';
import { getQuestions } from '../../../services/orders/questionsService';

const initialState = {
  selectedArea: null,
  selectedPatient: null,
  currentPatientBranch: null,
  productPriorityMap: {},
  availableCategories: [],
  selectedCategory: null,
  selectedSubCategory: null,
  questions: [],
  configuredEquipment: {},
  fullListProd: {},
};

export const useOrderFlowStore = create((set) => ({
  ...initialState,
  areas: [
    {
      Categoria: 'Implantação',
      shortDescription: 'Solicite a implantação de equipamentos.',
      coverImageURL: '/area/implantacao.jpg',
      categories: [
        {
          id: 'Oxigenoterapia',
          title: 'Oxigenoterapia',
          coverImageURL: '/categoria/implantacao/oxigenoterapia/main.jpg',
          shortDescription:
            'Locação de equipamentos para tratamento com oxigênio',
        },
        {
          id: 'Ventilação domiciliar/Linha do sono',
          title: 'Linha do sono',
          coverImageURL: '/categoria/implantacao/linhaDoSono/main.jpg',
          shortDescription:
            'Equipamentos e acessórios para tratamento do distúrbio do sono',
        },
        {
          id: 'Linha do Sono',
          title: 'Linha do sono',
          coverImageURL: '/categoria/implantacao/linhaDoSono/main.jpg',
          shortDescription:
            'Locação de equipamentos para tratamento do distúrbio do sono',
        },
        {
          id: 'Ventilação Domiciliar',
          title: 'Ventilação domiciliar',
          coverImageURL: '/categoria/implantacao/ventilacaoDomiciliar/main.jpg',
          shortDescription:
            'Locação de equipamentos para terapias respiratórias invasivas e não invasivas',
        },
        {
          id: 'Oxímetros',
          title: 'Oxímetros',
          coverImageURL: '/categoria/implantacao/oximetros/main.jpg',
          shortDescription:
            'Locação de equipamentos que monitoram a saturação de oxigênio e a frequência cardíaca',
        },
        {
          id: 'Aspiradores de Secreção',
          title: 'Aspiradores de secreção',
          coverImageURL: '/categoria/implantacao/aspiradorDeSecrecao/main.jpg',
          shortDescription:
            'Locação de equipamentos que auxiliam a aspiração de secreção de um paciente',
        },
        {
          id: 'Dispositivos e Acessórios de equipamentos Médicos',
          title: 'Descartáveis para equipamentos médicos',
          coverImageURL:
            '/categoria/implantacao/dispositivosAcessorios/main.jpg',
          shortDescription: 'Solicitação de reposição dos descartáveis',
        },
      ],
    },
    {
      Categoria: 'Assistência técnica',
      shortDescription: 'Solicite assistência para equipamentos.',
      coverImageURL: '/area/assistenciaTecnica.jpg',
    },
    {
      Categoria: 'Recolhimento',
      shortDescription: 'Solicite o recolhimento de equipamentos.',
      coverImageURL: '/area/recolhimento.jpg',
    },
    {
      Categoria: 'Recarga',
      shortDescription: 'Solicite recarga ou troca de cilindros.',
      coverImageURL: '/area/recarga.jpg',
    },
    {
      Categoria: 'Descartáveis',
      shortDescription:
        'Solicite a reposição de materiais descartáveis do paciente.',
      coverImageURL: '/area/descartaveis.jpg',
    },
    {
      Categoria: 'Sublocação',
      shortDescription:
        'Área exclusiva para solicitação de equipamentos em sublocação e produtos descartáveis.',
      coverImageURL: '/area/sublocacao.jpg',
    },
  ],

  setSelectedArea: (selectedArea) => set({ selectedArea }),
  setSelectedPatient: (selectedPatient) => set({ selectedPatient }),
  setPatientBranch: (currentPatientBranch) => set({ currentPatientBranch }),
  setProductPriority: (productPriorityMap) => set({ productPriorityMap }),
  setAvailableCategories: (availableCategories) =>
    set({ availableCategories: (availableCategories ?? []).filter(Boolean) }),
  setSelectedCategory: (_cnpj, selectedCategory) => set({ selectedCategory }),
  setSelectedSubcategory: async (selectedSubCategory, selectedModel) => {
    const model = selectedModel ?? selectedSubCategory?.sap_code;
    let questions = [];
    try {
      questions = (await getQuestions(model)) ?? [];
    } catch (error) {
      console.warn(
        '[newOrderFlowStore] Não foi possível carregar perguntas:',
        error
      );
    }
    set({
      selectedSubCategory: { ...selectedSubCategory, selectedModel: model },
      questions: Array.isArray(questions) ? questions : questions?.data ?? [],
    });
  },
  setConfiguredEquipment: (configuredEquipment) => set({ configuredEquipment }),
  setFullListProd: (fullListProd) => set({ fullListProd }),
  // OrderSelectArea defines the area immediately before calling reset.  Keep
  // it so the following category screen can validate the current flow.
  reset: () =>
    set((state) => ({ ...initialState, selectedArea: state.selectedArea })),
}));
